module.exports = {
    "40": "xxu",
    "80": "xu",
    "160": "u",
    "300": "xxxs",
    "400": "xxs",
    "500": "xs",
    "600": "s",
    "700": "m",
    "750": "l",
    "900": "xl",
    "1100": "xxl",
    "1400": "xxxl"
};